<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Galería</h1>
    <div class="information" v-if="gallery">
      <p class="information__text"><strong class="information__text--strong">Nombre: </strong>{{gallery.name}}</p>
      <p v-if="gallery.title" class="information__text"><strong class="information__text--strong">Título: </strong>{{gallery.title}}</p>
      <p v-if="gallery.description" class="information__text"><strong class="information__text--strong">Descripción: </strong><br><span v-html="description"></span></p>
      <p v-if="gallery.group_name" class="information__text"><strong class="information__text--strong">Grupo: </strong>{{gallery.group_name}}</p>
      <p v-if="status" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{status}}</p>
      <p v-if="gallery.cover" class="information__text"><strong class="information__text--strong">Cover de la galería:</strong></p>
      <img v-if="gallery.cover" :src="cover" :alt="gallery.name" class="information__image information__image--wide">
    </div>
  </div>
</template>

<script>
import {gallery_status} from './mocks'
import {nl2br} from '@/core/libs/functions'
import {config} from '@/core/config/base'
export default {
  props: {
    gallery: {
      type: Object
    }
  },
  computed: {
    status: function () {
      let status = gallery_status.filter(element => element.id === this.gallery.status_id)
      return status[0].name
    },
    description: function () {
      return nl2br(this.gallery.description)
    },
    cover: function () {
      let img = ''
      if (this.gallery.cover) {
        img = config.statics.url + JSON.parse(this.gallery.cover).sizes.small
      }
      return img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/galleries/view.vue